var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { mapOutskirtCalloutOffset } from "../../constants/mapOutskirtCalloutOffset";
import { selectOutskirtBuildingInfo, selectOutskirtBuildingLevel, selectOutskirtBuildingMaxLevel, selectOutskirtExternalBarnHasDiscount, selectSelectedOutskirtBuildingId, } from "../../selectors/selectOutskirtBuildingInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilBuildings } from "../../utils/utilBuildings";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { ContextMenuDetails } from "../context-menu/ContextMenuDetails";
import { ErrorBoundary } from "../generic/ErrorBoundary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { mapOutskirtsPosition } from "../scenes/mapOutskirtsPosition";
import { ViewportWorldSpace } from "../viewport/ViewportWorldSpace";
var Point = PIXI.Point;
export var _ContextMenuOutskirtsBuilding = function (props) {
    var building = props.building, contextMenuCoords = props.contextMenuCoords;
    if (!building || !contextMenuCoords) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "ContextMenuOutskirtsBuildingDOM.tsx" },
        React.createElement(ViewportWorldSpace, null, function (viewport) {
            return renderComponent(__assign({}, props, { building: building, contextMenuCoords: contextMenuCoords, viewport: viewport }));
        })));
};
var renderComponent = function (_a) {
    var building = _a.building, contextMenuCoords = _a.contextMenuCoords, onInfo = _a.onInfo, onUpgrade = _a.onUpgrade, canUpgrade = _a.canUpgrade, hasDiscount = _a.hasDiscount, viewport = _a.viewport;
    var descriptionDisplay = getDescriptionDisplay(building);
    var position = getContextMenuPosition(viewport, contextMenuCoords);
    return (React.createElement(React.Fragment, null,
        React.createElement(ContextMenuDetails, { position: position, building: building, descriptionDisplay: descriptionDisplay, onInfo: onInfo, onUpgrade: onUpgrade, onMove: function () { return undefined; }, canUpgrade: canUpgrade, canMove: false, hasDiscount: hasDiscount, showBouncingArrow: false })));
};
var getContextMenuPosition = function (viewport, contextMenuCoords) {
    return viewport.toGlobal(new Point(contextMenuCoords.x, contextMenuCoords.y));
};
var getDescriptionDisplay = function (building) {
    var level = utilBuildings.getProtoStage(building, 1);
    var buildingStages = building.balancing.outsideBuildingStage;
    var shouldShowLevel = buildingStages.length > 1;
    var levelLocaReplacements = new Map([[ReplacementLoca.zero_0, level.toString()]]);
    return shouldShowLevel && React.createElement(TextLoca, { id: IdLoca.stageX, replacements: levelLocaReplacements });
};
var mapState = function (state) {
    var buildingId = selectSelectedOutskirtBuildingId(state);
    if (buildingId) {
        var building = selectOutskirtBuildingInfo(state, buildingId);
        var buildingCoords = mapOutskirtsPosition.get(buildingId);
        var calloutOffset = mapOutskirtCalloutOffset.get(buildingId);
        var currentLevel = selectOutskirtBuildingLevel(state, buildingId);
        var maxLevel = selectOutskirtBuildingMaxLevel(state, buildingId);
        return {
            building: building,
            canUpgrade: currentLevel < maxLevel,
            contextMenuCoords: {
                x: buildingCoords.x + calloutOffset.x,
                y: buildingCoords.y + calloutOffset.y,
            },
            hasDiscount: selectOutskirtExternalBarnHasDiscount(state),
        };
    }
    return {
        building: undefined,
        canUpgrade: false,
        contextMenuCoords: undefined,
        hasDiscount: false,
    };
};
var mapDispatch = function (dispatch) { return ({
    onInfo: function () { return dispatch(actionModalOpen(IdModal.ExternalBarnInfo)); },
    onUpgrade: function () { return dispatch(actionModalOpen(IdModal.ExternalBarnUpgrade)); },
}); };
export var ContextMenuOutskirtsBuildingDOM = connect(mapState, mapDispatch)(_ContextMenuOutskirtsBuilding);



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/ContextMenuOutskirtsBuildingDOM.tsx
// module id = 2259
// module chunks = 3